import { CurrencyPipe, DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXsrfConfiguration,
} from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from 'src/environments/environment';
import { ApiModule, BASE_PATH } from 'swagger-client';
import { routes } from './app-routes';
import AppPreset from './primeng-app-preset';
import { AuthInterceptor } from './shared/guard/auth.interceptor';
import { HttpXsrfInterceptor } from './shared/guard/csrf.interceptor';
import { ErrorInterceptor } from './shared/guard/error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptorsFromDi(),
      withXsrfConfiguration({
        cookieName: 'Csrf-Token',
        headerName: 'Csrf-Token',
      }),
    ),
    importProvidersFrom(ApiModule, BrowserModule),
    provideTranslateService({
      loader: provideTranslateHttpLoader(),
    }),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: AppPreset,
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'styles, tailwind-base, primeng, tailwind-utilities',
          },
          darkModeSelector: false || 'none',
        },
      },
    }),
    DatePipe,
    CurrencyPipe,
    DecimalPipe,
    PercentPipe,
    { provide: HTTP_INTERCEPTORS, useClass: HttpXsrfInterceptor, multi: true },
    { provide: BASE_PATH, useValue: environment.API_BASE_PATH },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ConfirmationService,
    MessageService,
    DialogService,
  ],
};
